import { ChangeDetectorRef, Directive, OnInit, OnDestroy, ElementRef, Input } from '@angular/core';
import { DatePickerComponent } from '@progress/kendo-angular-dateinputs';

@Directive({
  selector: '[spv2DateInputResetButton]'
})
export class DateInputResetButtonDirective implements OnInit, OnDestroy {
  private button: HTMLElement;
  private clickHandler = (e: Event) => {
    e.stopPropagation();
    this.component.value = null;
    this.component.valueChange.emit(null);
    this.cdr.markForCheck();
  }
  
  @Input('spv2DateInputResetButton') isVisible: boolean = true;

  constructor(private readonly component: DatePickerComponent, private readonly cdr: ChangeDetectorRef, private readonly el: ElementRef) { }
  
  public ngOnInit(): void {
    if(this.isVisible){
      this.button = document.createElement('span');
      this.button.className = 'k-icon k-clear-value k-i-close';
      this.button.addEventListener('click', this.clickHandler);

      this.getDateInputElement()?.appendChild(this.button);
    }
  }
  
  public ngOnDestroy(): void {
    this.button.removeEventListener('click', this.clickHandler);
  }

  private getDateInputElement(): any {
    if(this.el.nativeElement.children) {
      return [...this.el.nativeElement.children].find(x => x.localName.endsWith("kendo-dateinput"));
    }
   
    return null;
  }
}